/**
 * Business function. make query newItem function for API call.
 * @param {array} searchAttributesArray the attributes to search in
 * @param {boolean} useEntities
 * @returns {function({search?: *, page?: *, pageSize?: *, entities?: *, sort: *, sortBy: *, attributesObj: *, serverSideAttributeKeys: *}): {limit: (*|number)}} The makeQueryParams function.
 */
import {
  getAttributeList,
  initQueryParams,
  makeQueryParam$eq,
  makeQueryParam$instr,
  makeSearchQueryParams,
} from '@/business/apiTreatment/request/queryParamsUtils';

const makeListRequest = ({
  limitItemsRequest,
  useEntities,
  navFullIdField = 'entity_nav_full_id',
  obsoleteAllowed = false,
  dateField,
}) => ({ search, page, pageSize, entities, sort, sortBy, attributesObj }) => {
  const AndQueryParams = [];
  const queryParams = initQueryParams({
    limitItemsRequest,
    pageSize,
    page,
    sort,
    sortBy,
    useEntities,
    entities,
    navFullIdField,
    AndQueryParams,
  });

  const andAttributeFilterParams = [];
  andAttributeFilterParams.push({
    $or: [
      {
        obsolete_subcontractor: { $eq: 'N' },
      },
      { obsolete_subcontractor: { $null: null } },
    ],
  });
  if (!obsoleteAllowed) {
    andAttributeFilterParams.push({
      $or: [
        {
          phone_obsolete: { $eq: 'N' },
        },
        { phone_obsolete: { $null: null } },
      ],
    });
    andAttributeFilterParams.push({
      $or: [
        {
          email: { $notnull: null },
        },
        { phone: { $notnull: null } },
      ],
    });
  }

  if (andAttributeFilterParams.length > 0) {
    AndQueryParams.push({
      $and: andAttributeFilterParams,
    });
  }

  getAttributeList(attributesObj, '$eq').forEach(
    makeQueryParam$eq(attributesObj, AndQueryParams)
  );

  getAttributeList(attributesObj, '$instr').forEach(
    makeQueryParam$instr(attributesObj, AndQueryParams)
  );

  makeSearchQueryParams(search, AndQueryParams);

  AndQueryParams.push({
    $or: [
      {
        [dateField]: {
          $gte: { $date: new Date().toISOString() },
        },
      },
      {
        [dateField]: { $null: null },
      },
      {
        end_date: {
          $lte: { $date: '1000-01-01T00:00:00.000Z' },
        },
      },
    ],
  });

  if (AndQueryParams.length > 0) {
    queryParams.q = {
      ...queryParams.q,
      $and: AndQueryParams,
    };
  }

  return queryParams;
};

export default makeListRequest;
